module.exports = __webpack_public_path__ + "static/media/chrome-allow-prompt.dc1658e6.png";